import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';

type ClientWithLastReview = {
  id: string;
  lastSuitabilityReportDate: string | null;
};

export function useClientsLastReviewDates(clientIds?: string[]) {
  const ids = useMemo(() => (clientIds ?? []).filter((x): x is string => !!x), [clientIds]);

  const {
    data: allClientsData,
    isLoading,
    isError,
    refetch,
  } = useQuery<ClientWithLastReview[]>({
    queryKey: ['clients-with-last-review'],
  });

  const byClientId = useMemo(() => {
    const out: Record<string, Date | undefined> = {};

    if (!allClientsData) return out;

    allClientsData.forEach(client => {
      if (client.lastSuitabilityReportDate) {
        out[client.id] = new Date(client.lastSuitabilityReportDate);
      } else {
        out[client.id] = undefined;
      }
    });

    return out;
  }, [allClientsData]);

  const reviewDates = useMemo(() => ids.map(id => byClientId[id]), [ids, byClientId]);

  return { byClientId, reviewDates, isLoading, isError, refetch };
}
